<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image poc-vs-radio-splash" v-if="!isMobile()">
                                        <img alt="Evolution of PTT" src="./assets/ptt-evolution.svg">
                                    </figure>
                                    <figure class="image poc-vs-radio-splash mobile-screen" v-else>
                                        <img alt="Evolution of PTT" src="./assets/ptt-evolution.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('poc-vs-radio:poc-vs-radio.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('poc-vs-radio:poc-vs-radio.subtitle') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- NGN section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('poc-vs-radio:poc-vs-radio.ngn_title_up')">
                        </h3>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc-vs-radio:poc-vs-radio.ngn_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-700" v-if="!isMobile()">
                            <img alt="Next Generation Network PTT" src="./assets/ngn-network.svg">
                        </figure>
                        <figure class="image img-700 mobile-screen" v-else>
                            <img alt="Next Generation Network PTT" src="./assets/ngn-network.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc-vs-radio:poc-vs-radio.ngn_description2') }}
                        </p>
                    </div>
                </div>

            </div>
        </section>

        <!-- New vs old section -->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('poc-vs-radio:poc-vs-radio.features_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7">
                            {{ $t('poc-vs-radio:poc-vs-radio.features_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container has-padding-2x">
                        <table class="steelBlueCols uptin-text-7">
                            <thead>
                            <tr>
                                <th class="">&nbsp;</th>
                                <th class="uptin-text-center">{{ $t('poc-vs-radio:poc-vs-radio.head1') }}</th>
                                <th class="uptin-text-center">{{ $t('poc-vs-radio:poc-vs-radio.head2') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item1') }}</td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-check text-green"></i></td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-check text-green"></i></td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item2') }}</td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-times text-green"></i></td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-check text-red"></i></td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item3') }}</td>
                                <td class="uptin-text-center text-blue">{{ $t('poc-vs-radio:poc-vs-radio.coming_soon') }}</td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-times text-red"></i></td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item4') }}</td>
                                <td class="uptin-text-center"><i class="fas fa-check text-green"></i></td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-times text-red"></i></td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item5') }}</td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-check text-green"></i></td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-times text-red"></i></td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item6') }}</td>
                                <td class="uptin-text-center text-blue">{{ $t('poc-vs-radio:poc-vs-radio.in_coverage') }}</td>
                                <td class="uptin-text-center text-blue">{{ $t('poc-vs-radio:poc-vs-radio.in_antenna') }}</td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item7') }}</td>
                                <td class="uptin-text-center text-green">{{ $t('poc-vs-radio:poc-vs-radio.low') }}</td>
                                <td class="uptin-text-center text-red">{{ $t('poc-vs-radio:poc-vs-radio.high') }}</td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item8') }}</td>
                                <td class="uptin-text-center text-green">{{ $t('poc-vs-radio:poc-vs-radio.dont_have') }}</td>
                                <td class="uptin-text-center text-red">{{ $t('poc-vs-radio:poc-vs-radio.high') }}</td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item9') }}</td>
                                <td class="uptin-text-center text-green">AES 256</td>
                                <td class="uptin-text-center text-green">{{ $t('poc-vs-radio:poc-vs-radio.in_some_versions') }}</td>
                            </tr>
                            <tr>
                                <td class="">{{ $t('poc-vs-radio:poc-vs-radio.item10') }}</td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-check text-green"></i></td>
                                <td class="uptin-text-center">&nbsp;<i class="fas fa-times text-red"></i></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <download-app></download-app>
        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">
    .poc-vs-radio-splash {
        max-width: 700px;
        min-width: 700px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"
    import DownloadApp from "@/components/download-app/download-app"

    export default {
        components: {
            PayAsYouGo,
            DownloadApp
        },
        name: 'uptin-poc',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
